import React, { useEffect, useState } from "react";
import api from "services/api";
import { CSSTransition } from "react-transition-group";
import "./QuestionPage.css";

const QuestionPage = ({ questionId, onNext }) => {
  const [question, setQuestion] = useState(null);
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    const fetchQuestion = async () => {
      try {
        setShowContent(false); // Reset animation state before fetching
        const response = await api.get(`/funnel-questions/${questionId}/`);
        setQuestion(response.data);
        // Small delay to ensure the content is ready before starting animation
        setTimeout(() => {
          setShowContent(true);
        }, 50);
      } catch (error) {
        console.error("Error fetching question:", error);
      }
    };

    fetchQuestion();
  }, [questionId]);

  if (!question) {
    return null;
  }

  const handleOptionSelect = (optionId) => {
    const existingAnswers = JSON.parse(localStorage.getItem("answers")) || [];
    const newAnswer = { questionId, optionId };
    existingAnswers.push(newAnswer);
    localStorage.setItem("answers", JSON.stringify(existingAnswers));
    onNext();
  };

  return (
    <div className="question-container">
      <CSSTransition
        in={showContent}
        timeout={500}
        classNames="fade"
        unmountOnExit
        appear={true}
      >
        <div className="question-content">
          <h2 className="text-2xl font-semibold mb-4">{question?.question}</h2>
          <div className="space-y-4">
            {question?.options.map((option) => (
              <button
                key={option.id}
                className="flex items-center p-4 bg-gray-100 rounded-lg w-full border border-gray-300 hover:border-gray-500"
                onClick={() => handleOptionSelect(option.id)}
              >
                {option.photo && (
                  <img
                    src={option.photo}
                    alt={option.text}
                    className="w-12 h-12 mr-4 object-cover rounded-full"
                  />
                )}
                <span className="text-lg">{option.text}</span>
              </button>
            ))}
          </div>
          <div className="flex justify-end mt-6">
            <button
              onClick={onNext}
              className="px-6 py-2 bg-selected text-white rounded-full"
            >
              Next
            </button>
          </div>
        </div>
      </CSSTransition>
    </div>
  );
};

export default QuestionPage;
